"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpretMultivariateNode = void 0;
const matchStatus_1 = require("./matchStatus");
const rng_1 = require("./rng");
// Bucketing by percent
function interpretMultivariateNode(ruleNode, context, interpretNode) {
    const { bucketKey, buckets, children } = ruleNode;
    const bucketValue = context.getProperty(bucketKey);
    if (bucketValue == null) {
        context.sendError(
        // tslint:disable-next-line:max-line-length
        `Property ${bucketKey} not found for dynamic value ${context.getDynamicValueName()} `);
        context.addResolutionLog(`Context missing bucket property: ${ruleNode.bucketKey}`);
        return matchStatus_1.error();
    }
    context.addResolutionDetails({
        bucket_key: bucketValue.toString(),
        bucket_key_type: bucketKey,
    });
    let bucketPercent = rng_1.getBucketPercent(String(bucketValue), context);
    const originalBucketPercent = bucketPercent;
    for (let i = 0; i < buckets.length; i += 1) {
        if (bucketPercent < buckets[i]) {
            context.addResolutionLog(`SUCCESS: ${originalBucketPercent} matches bucket ${i}`);
            return interpretNode(children[i], context);
        }
        context.addResolutionLog(`FAILURE: ${bucketPercent} does not match bucket ${i}`);
        bucketPercent = bucketPercent - buckets[i];
    }
    // Fallback
    context.addResolutionLog(`FALLBACK: resolving last bucket`);
    return interpretNode(children[children.length - 1], context);
}
exports.interpretMultivariateNode = interpretMultivariateNode;
//# sourceMappingURL=multivariateNode.js.map